import { render, staticRenderFns } from "./FaturamentoEvolucaoVolumeVendas.vue?vue&type=template&id=eb9959ee&scoped=true&"
import script from "./FaturamentoEvolucaoVolumeVendas.vue?vue&type=script&lang=js&"
export * from "./FaturamentoEvolucaoVolumeVendas.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoEvolucaoVolumeVendas.vue?vue&type=style&index=0&id=eb9959ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9959ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
